$(document).ready(function () {
	console.log('document is ready!');

	$('html').removeAttr('x-cloak');

	$('.c-header__activator').on('click', function () {
		$('aside.c-navigation-drawer').addClass('c-navigation-drawer--active');
		$('html, body').addClass('overflow-hidden');
	});
	$('.c-navigation-drawer__overlay').on('click', function () {
		$('aside.c-navigation-drawer').removeClass('c-navigation-drawer--active');
		$('html, body').removeClass('overflow-hidden');
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > 152) {
			$('.scrollButton').removeClass('invisible opacity-0').addClass('visible opacity-100');
		} else {
			$('.scrollButton').removeClass('visible opacity-100').addClass('invisible opacity-0');
		}
	});

	$('.scrollButton').on('click', function () {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	/* epat page filter */
	$('.epatContent').hide();
	$('.epatContent:first').show();

	$('.epatButton').on('click', function (e) {
		e.preventDefault();

		let href = $(this).attr('href');

		$('.epatButton').removeClass('blue-button--active');
		$(this).addClass('blue-button--active');

		$('.epatContent').slideUp('fast');
		$('.epatContent' + href).slideDown('fast');
	});
	/* ## epat page filter */

	/* conditions and procedures page filter */
	$('[data-filter-category]').on('click', function () {
		let category = $(this).data('filter-category');

		$('[data-filter-category]').removeClass('active');
		$(this).addClass('active');

		if (category === '') {
			$('.conditions-tab__content div a').show();
		} else {
			$('.conditions-tab__content div a').hide();
			$('.conditions-tab__content div a').filter(`.filter--${category}`).show();
		}
	});
	/* ## conditions and procedures page filter */
});

/* import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import collapse from '@alpinejs/collapse';

Alpine.plugin(mask);
Alpine.plugin(collapse);

Alpine.store('global', {
  isNavigationDrawerActive: false,
  toggleNavigationDrawer() {
    this.isNavigationDrawerActive = !this.isNavigationDrawerActive;
  }
});

Alpine.data('conditions', () => ({
  activeTab: '',
  setActiveTab(name) {
    this.activeTab = name;
  },
  showTabs(tabs) {
    let activeTab = this.activeTab;
    return tabs.some((tab) => tab === activeTab);
  }
}));

window.Alpine = Alpine;
Alpine.start();
 */
